module.exports = __webpack_public_path__ + "6038f59c5a3089a90868fd6f8984c0fc.png";